"use client";

import React from "react";
import { ExternalLink } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";

/**
 * WebsiteForTradespeople — Section 5: Beispiel-Mockup
 * Drop-in für: src/pages/WebsiteForTradespeople/sections/BeispielMockup.tsx
 */

const HANDWERKER_IMG = "https://pagemaker.my-pagemaker24.com/wp-content/uploads/2026/04/Moler-scaled.png?v=a6tiktpldx";
export default function BeispielMockup() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="beispiel-mockup" className="bg-secondary py-20 md:py-24 overflow-hidden">
      <style>{`
        .hw-device-desktop{background:#fff;border-radius:12px;box-shadow:0 25px 50px -12px rgba(0,0,0,.15);overflow:hidden;border:1px solid #e5e7eb}
        .hw-device-tablet{background:#1a1c23;border-radius:20px;padding:10px;box-shadow:0 20px 40px -10px rgba(0,0,0,.2)}
        .hw-device-tablet .screen{background:#fff;border-radius:8px;overflow:hidden}
        .hw-device-mobile{background:#1a1c23;border-radius:28px;padding:6px;box-shadow:0 20px 40px -10px rgba(0,0,0,.2)}
        .hw-device-mobile .screen{background:#fff;border-radius:20px;overflow:hidden}
        .hw-device-mobile .notch{width:40%;height:4px;background:#2a2c33;border-radius:4px;margin:4px auto 2px}
      `}</style>

      <div ref={ref} className={`max-w-6xl mx-auto px-4 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-14">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-foreground mb-4 leading-tight">
            Beispiel: Maler-Website
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground">
            Erstellt mit dem PAGEMAKER24 Vibe Builder — perfekt auf jedem Gerät.
          </p>
        </div>

        <div className="flex items-end justify-center gap-4 md:gap-8 max-w-5xl mx-auto">
          <div className="hidden md:block" style={{
          width: "58%"
        }}>
            <div className="hw-device-desktop">
              <div className="h-8 bg-gray-100 border-b border-gray-200 flex items-center px-3 gap-1.5">
                <div className="w-2.5 h-2.5 rounded-full bg-red-300" />
                <div className="w-2.5 h-2.5 rounded-full bg-yellow-300" />
                <div className="w-2.5 h-2.5 rounded-full bg-green-300" />
                <div className="mx-auto text-[10px] text-gray-400 font-medium">
                  colorcraft-bern.ch
                </div>
              </div>
              <div className="aspect-[16/10] overflow-hidden bg-gray-100">
                <img src={HANDWERKER_IMG} alt="Maler Website Desktop" className="w-full h-full object-cover object-top" />
              </div>
            </div>
            <p className="text-center text-xs text-muted-foreground mt-3 font-medium">
              Desktop
            </p>
          </div>

          <div className="hidden md:block" style={{
          width: "22%"
        }}>
            <div className="hw-device-tablet">
              <div className="screen aspect-[3/4] overflow-hidden">
                <img src={HANDWERKER_IMG} alt="Maler Website Tablet" className="w-full h-full object-cover object-top" />
              </div>
            </div>
            <p className="text-center text-xs text-muted-foreground mt-3 font-medium">
              Tablet
            </p>
          </div>

          <div className="flex-shrink-0" style={{
          width: "14%",
          minWidth: "110px"
        }}>
            <div className="hw-device-mobile">
              <div className="screen">
                <div className="notch" />
                <div className="aspect-[9/16] overflow-hidden">
                  <img src={HANDWERKER_IMG} alt="Maler Website Mobile" className="w-full h-full object-cover object-top" />
                </div>
              </div>
            </div>
            <p className="text-center text-xs text-muted-foreground mt-3 font-medium">
              Mobile
            </p>
          </div>
        </div>

        <div className="text-center mt-10">
          <a href="https://civil-seal.my-pagemaker24.com/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-primary font-medium hover:underline text-lg">
            Live-Demo ansehen
            <ExternalLink className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>;
}